import styled, { css } from 'styled-components';
import { TableCol } from '@pickit/pickit-grid-system';

export const Cell = styled(TableCol)<{
  align: string;
  type: string;
}>`
  align-items: ${({ align }) => align};
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ type }) =>
    type !== 'button' &&
    css`
      margin: 9px 0;
    `}
  overflow: hidden;
  white-space: pre-line;
`;
